import React, { useEffect, useState } from "react";
import { Button, CircularProgress, Box } from "@mui/material";
import { flushSync } from "react-dom";

export const LoadingButton = ({ loading, children, loadingText, ...props }) => {
  const buttonRef = React.useRef(null);
  const [width, setWidth] = useState(null);

  useEffect(() => {
    let intersectionObserver = null;
    // save reference for don't lost it at useEffect cleanup
    const buttonElement = buttonRef.current;

    const updateWidth = () => {
      const widthPropWithPercentage =
        String(props.sx?.width ?? "").includes("%") ||
        String(props.sx?.width?.xs ?? "").includes("%") ||
        String(props.sx?.width?.sm ?? "").includes("%") ||
        String(props.sx?.width?.md ?? "").includes("%") ||
        String(props.sx?.width?.lg ?? "").includes("%");

      if (buttonRef.current && !widthPropWithPercentage) {
        setWidth(buttonRef.current.offsetWidth);
      }
    };

    function handleResize() {
      flushSync(() => {
        setWidth(null);
      });
      updateWidth();
    }
    if (buttonElement) {
      window.addEventListener("resize", handleResize);

      intersectionObserver = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          updateWidth();
        }
      });
      intersectionObserver.observe(buttonElement);
    }

    return () => {
      if (buttonElement) {
        window.removeEventListener("resize", handleResize);
      }
      if (intersectionObserver && buttonElement) {
        intersectionObserver.unobserve(buttonElement);
        intersectionObserver.disconnect();
      }
    };
  }, [props.sx]);

  const circularProgressSize = {
    grown: 24,
    shrinked: 24,
    large: 23,
    small: 10,
    micro: 8,
    default: 24,
  }[props.size || "default"];

  return (
    <Button
      ref={buttonRef}
      disabled={loading}
      {...props}
      sx={{ ...props.sx, ...(width ? { width, minWidth: width } : {}) }}
    >
      {loading ? (
        <>
          <CircularProgress
            size={circularProgressSize}
            color="inherit"
            sx={{ alignContent: "center" }}
          />
          <Box sx={{ display: "block", ml: loadingText ? 1.5 : 0 }}>
            <span>{loadingText}</span>
          </Box>
        </>
      ) : (
        <span>{children}</span>
      )}
    </Button>
  );
};
